<template>
  <div id="orderOptions">

    <PageTitle :title="$t('order_options.title')" :subtitle="$t('order_options.subtitle')"></PageTitle>

    <PageContainer>
      <div class="container-title">{{$t('order_options.rc_section_title')}}</div>
      <label class="container-description" v-html="$t('order_options.rc_section_description')"></label>
      <div class="columns">
        <div class="column">
          <div class="subtitle">{{$t('pos_method.takeout')}}</div>
          <div class="group">
            <label>{{$t('activated')}}</label>
            <select v-model="methods.takeout.activated">
              <option :value="true">{{$t('yes')}}</option>
              <option :value="false">{{$t('no')}}</option>
            </select>
          </div>
          <div class="group">
            <label>{{$t('order_options.linked_revenue_center')}}</label>
            <select v-model="methods.takeout.revenueCenter">
              <option :value="null" disabled hidden>{{$t('choose')}}...</option>
              <option :value="rc.ref" v-for="rc of revenueCenters"
                      :key="`rc_takeout_${rc.id}`">{{$to(rc.name)}}</option>
            </select>
          </div>
          <br>
          <div class="subtitle">{{$t('pos_method.delivery')}}</div>
          <div class="group">
            <label>{{$t('activated')}}</label>
            <select v-model="methods.delivery.activated">
              <option :value="true">{{$t('yes')}}</option>
              <option :value="false">{{$t('no')}}</option>
            </select>
          </div>
          <div class="group">
            <label>{{$t('order_options.linked_revenue_center')}}</label>
            <select v-model="methods.delivery.revenueCenter">
              <option :value="null" disabled hidden>{{$t('choose')}}...</option>
              <option :value="rc.ref" v-for="rc of revenueCenters"
                      :key="`rc_delivery_${rc.id}`">{{$to(rc.name)}}</option>
            </select>
          </div>
        </div>

        <div class="column">
          <div class="subtitle">{{$t('pos_method.inPlace')}}</div>
          <div class="group">
            <label>{{$t('activated')}}</label>
            <select v-model="methods.inPlace.activated">
              <option :value="true">{{$t('yes')}}</option>
              <option :value="false">{{$t('no')}}</option>
            </select>
          </div>
          <div class="group">
            <label>{{$t('order_options.linked_revenue_center')}}</label>
            <select v-model="methods.inPlace.revenueCenter">
              <option :value="null" disabled hidden>{{$t('choose')}}...</option>
              <option :value="rc.ref" v-for="rc of revenueCenters"
                      :key="`rc_inPlace_${rc.id}`">{{$to(rc.name)}}</option>
            </select>
          </div>
          <br>
          <div class="subtitle">{{$t('pos_method.table')}}</div>
          <div class="group">
            <label>{{$t('activated')}}</label>
            <select v-model="methods.table.activated">
              <option :value="true">{{$t('yes')}}</option>
              <option :value="false">{{$t('no')}}</option>
            </select>
          </div>
          <div class="group">
            <label>{{$t('order_options.linked_revenue_center')}}</label>
            <select v-model="methods.table.revenueCenter">
              <option :value="null" disabled hidden>{{$t('choose')}}...</option>
              <option :value="rc.ref" v-for="rc of revenueCenters"
                      :key="`rc_table_${rc.id}`">{{$to(rc.name)}}</option>
            </select>
          </div>
        </div>
      </div>
    </PageContainer>

    <PageFooter :mainAction="{action: save, text: $t('save')}"></PageFooter>

  </div>
</template>

<script>
  import PageTitle from "@/components/PageTitle";
  import PageContainer from "@/components/PageContainer";
  import PageFooter from "@/components/PageFooter";
  import {mapActions} from "vuex";

  export default {
    name: "OrderOptions",

    components: { PageTitle, PageContainer, PageFooter },

    data() {
      return {
        revenueCenters: [],
        methods: {
          takeout: {
            activated: true,
            revenueCenter: null
          },
          delivery: {
            activated: true,
            revenueCenter: null
          },
          inPlace: {
            activated: true,
            revenueCenter: null
          },
          table: {
            activated: true,
            revenueCenter: null
          }
        }
      }
    },

    async mounted() {
      this.$store.state.pageTitleTranslationKey = "order_options.title";
      this.$store.state.pageIcon = "/icon/order.svg";

      showSpinner();
      await this.loadCompany();
      await this.loadRevenueCenters();
      hideSpinner();
    },

    computed: {
      companyId() {
        return this.$route.query.company;
      },
      branchId() {
        return this.$route.query.branch;
      }
    },

    methods: {
      ...mapActions(["getCompany", "saveCompany", "getRevenueCenters"]),

      async loadRevenueCenters() {
        let response = await this.getRevenueCenters(this.companyId);
        if (response && response.revenueCenters) {
          this.revenueCenters = response.revenueCenters;
        }
      },

      async loadCompany() {
        let response = await this.getCompany({
          branchId: this.branchId,
          companyId: this.companyId,
          augment: "backend"
        });
        if (response && response.settings && response.settings.methods) {
          let c = response.settings.methods;
          Object.assign(this.methods.takeout, c.takeout || {});
          Object.assign(this.methods.delivery, c.delivery || {});
          Object.assign(this.methods.inPlace, c.inPlace || {});
          Object.assign(this.methods.table, c.table || {});
        }
      },

      async save() {
        let data = {
          settings: {
            methods: this.methods
          }
        };
        showSpinner();
        let response = await this.saveCompany({
          branchId: this.branchId,
          companyId: this.companyId,
          data
        });
        hideSpinner();
        if (response) {
          toast(this.$t("order_options.save_success"), "success", this.$t("success"));
        } else {
          toast(this.$t("order_options.save_error"), "error", this.$t("error.title"));
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  #orderOptions {
    display: flex;
    flex-direction: column;

    .page-container {
      flex-grow: 1;
    }
  }

  .container-title {
    font-size: 16px;
    font-weight: bold;
    color: #1A1A1A;
  }
  .container-description {
    margin-bottom: 40px;
  }
</style>